import React, { useState, useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { fadeIn } from "../../../variants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import emailjs from "@emailjs/browser";
import "./index.css";

const Contact = () => {
  const [animationPlayed, setAnimationPlayed] = useState(false);

  useEffect(() => {
    setAnimationPlayed(true); // Marque l'animation comme jouée une fois que le composant est monté
  }, []);

  // Email JS
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_6lvblqo",
        "template_yjmtaxh",
        form.current,
        "pgp1hpfpOmLlkG7rz"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success(
            "Notre équipe vous remercie pour votre message qui sera traité dans les meilleurs délais. Cordialement, Vincent Fernandel Production",
            {
              autoClose: 10000,
            }
          );
          setTimeout(() => {
            document.location.href = "/";
          }, 10000);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="contact" id="contact">
      <div className="form">
        <h2 className="title">CONTACT</h2>
        <div className="contact-border"></div>
        <motion.div
          variants={fadeIn("right", 0.2)}
          initial="hidden"
          whileInView={"show"}
          viewport={{ once: false, amount: 0.3 }}
          animate={animationPlayed ? "show" : "hidden"} // Utilisation de l'état pour déterminer l'animation
        >
          <div className="text-center max-w-15 italic  my-5">
            <h2>
              {" "}
              <div className="flex flex-col items-center">
                <span className="text-slate-300 text-[22px] max-sm:text-[16px]">
                  N’hésitez pas à nous contacter pour toute demande concernant
                  nos artistes ou vos propres projets musicaux.
                  <span>
                    <br />
                    Toute requête sans rapport avec notre activité ne sera pas
                    traitée.
                  </span>{" "}
                </span>
              </div>
            </h2>
          </div>

          <form ref={form} onSubmit={sendEmail}>
            {/* Name */}
            <label htmlFor="name">NOM</label>
            <input
              type="name"
              name="user_name"
              placeholder="Nom et prénom"
              required
            />

            {/* Mail */}
            <label htmlFor="mail">MAIL</label>
            <input
              type="email"
              name="user_mail"
              placeholder="votremail@email.com"
              required
            />

            {/* Phone */}
            <label htmlFor="phone">TELEPHONE</label>
            <input type="phone" name="user_phone" placeholder="+33" />

            {/* Message */}
            <label htmlFor="message">MESSAGE</label>
            <textarea
              name="user_message"
              placeholder="Entrez votre message..."
              required
              minLength={10}
            />

            {/* Submit */}
            <button type="submit" value="Send" className="contact-btn">
              ENVOYER
            </button>
          </form>
        </motion.div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default Contact;
